<div id="app"><component :is="layout"><router-view></router-view></component></div>